import React from 'react';
import PropTypes from 'prop-types';
import {
  MatchCardDataBlock,
  IMatchCardDataBlock,
  IMatchDataBlockLayout,
} from '@sky-it-livedata/livedata-sports-design-system';
import { matchCardWidget } from '@sky-it-livedata/livedata-data-cards-widgets';

import { IWrapperModel } from '../../typings/common-types';
import { useService } from '../hooks/useService';
import { isEmptyObject, getModelFromUseService } from '../../utils/props-validator';

export interface IMatchCardWrapper extends IWrapperModel<IMatchCardDataBlock> {
  layout: Partial<IMatchDataBlockLayout>;
}

export const DEFAULT_LAYOUT: IMatchDataBlockLayout = {
  colorSchema: 'dark-light',
  fontSize: '16--14',
  logoSize: '30',
  size: 'small',
};

const MatchCardDetailWrapper: React.FC<IMatchCardWrapper> = ({ query, initialModel, live, layout }) => {
  const { model } = useService({
    live,
    query,
    widget: matchCardWidget,
    initialValue: initialModel,
  });
  const componentModel: IMatchCardDataBlock = getModelFromUseService(model);
  const isLoading = isEmptyObject(componentModel);

  return <MatchCardDataBlock {...componentModel} isLoading={isLoading} layout={{ ...DEFAULT_LAYOUT, ...layout }} />;
};

MatchCardDetailWrapper.propTypes = {
  initialModel: PropTypes.any.isRequired,
  layout: PropTypes.object.isRequired,
  live: PropTypes.bool,
  query: PropTypes.object.isRequired,
};

MatchCardDetailWrapper.defaultProps = {
  live: true,
};

export default MatchCardDetailWrapper;
